// extracted by mini-css-extract-plugin
export var chip = "_ex-0";
export var filterDropdown = "_ex-5";
export var filterItem = "_ex-6";
export var icon = "_ex-1";
export var removeButton = "_ex-3";
export var removeIcon = "_ex-4";
export var separator = "_ex-2";